"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Text_1 = require("../../foundations/Typography/Text");
const useId_1 = require("../../hooks/useId");
const Breadcrumb = (props) => {
    const colorClassName = `breadcrumb${(0, useId_1.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const { pages, expand, onClickPage } = props;
    const [showEllipses, setShowEllipses] = react_1.default.useState(true);
    const onClickEllipses = react_1.default.useCallback(() => {
        setShowEllipses(false);
    }, []);
    const colorStyles = {
        [`.${colorClassName}`]: {
            color: "text-secondary",
            textDecoration: "underline",
            textDecorationColor: "transparent",
            transition: "transition-color-medium"
        },
        [`&:hover .${colorClassName}`]: {
            color: "text-link-hover",
            textDecorationColor: "currentColor"
        },
        [`&:active .${colorClassName}`]: {
            color: "text-link-click",
            textDecorationColor: "currentColor"
        }
    };
    const renderEllipses = () => {
        return (react_1.default.createElement(foundations_1.Target, { sx: expand ? colorStyles : {}, onClick: expand ? onClickEllipses : undefined },
            react_1.default.createElement(Text_1.Text, { className: colorClassName, sx: { paddingInlineEnd: "spacing-3" }, variant: "title-2-regular", weight: "regular" }, "..."),
            react_1.default.createElement(Text_1.Text, { variant: "title-2-regular" }, "/")));
    };
    const totalPages = pages.length;
    const breadCrumb = pages.map((page, index) => {
        if (showEllipses && totalPages > 3) {
            if (index === 0) {
                return (react_1.default.createElement(react_1.default.Fragment, { key: "ellipsis" }, renderEllipses()));
            }
            if (index > 0 && index < totalPages - 3) {
                return null;
            }
        }
        const isFirst = index === 0;
        const isLast = index === totalPages - 1;
        const fontWeight = isLast ? "medium" : "regular";
        const onClickNav = () => {
            if (!isLast) {
                onClickPage(page.pageId);
            }
        };
        return (react_1.default.createElement(foundations_1.Target, { sx: Object.assign({ display: "flex" }, colorStyles), key: page.pageId, onClick: isLast ? undefined : onClickNav },
            react_1.default.createElement(Text_1.Text, { className: isLast ? undefined : colorClassName, sx: {
                    color: "text-emphasis",
                    paddingInlineStart: isFirst ? 0 : "spacing-3",
                    paddingInlineEnd: "spacing-3"
                }, variant: "title-2-regular", weight: fontWeight }, page.title),
            !isLast && react_1.default.createElement(Text_1.Text, { variant: "title-2-regular" }, "/")));
    });
    return (react_1.default.createElement(foundations_1.Box, { as: "nav", sx: {
            display: "flex",
            flexWrap: "wrap"
        } }, breadCrumb));
};
exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map